import de from './locales/de'
import en from './locales/en'
import ch from './locales/ch'
import pointsImporterStore from './store/general'
import pointsImporterProgress from './store/progress'
import pointsImporterState from './store/state'
import StateService from './services/state.service'
import DealerService from './services/dealer.service'
import ProgressService from './services/progress.service'
import RulesService from './services/rules.service'

export default {
  install: async (app, options) => {
    options.store.registerModule(
      'pointsImporterStore',
      pointsImporterStore
    )
    options.store.registerModule(
      'pointsImporterProgress',
      pointsImporterProgress
    )
    options.store.registerModule(
      'pointsImporterState',
      pointsImporterState
    )

    options.i18n.global.mergeLocaleMessage('de', de)
    options.i18n.global.mergeLocaleMessage('ch', ch)
    options.i18n.global.mergeLocaleMessage('en', en)

    app.config.globalProperties.$stateService = new StateService(
      options.store
    )

    app.config.globalProperties.$progressService = new ProgressService(
      options.store
    )

    app.config.globalProperties.$dealerService = new DealerService(
      options.store
    )

    app.config.globalProperties.$rulesService = new RulesService(
      options.store
    )
  }
}
